import { UseSearchState } from '@propertypal/shared/src/hooks/useSearchState';
import { SearchState } from '@propertypal/shared/src/reducers/search';
import { PropertyStyle } from '@propertypal/shared/src/types/propertyStyles';
import CheckItem from '@propertypal/web-ui/src/inputs/CheckItem';
import { InputLabel } from '@propertypal/web-ui/src/typography';
import React, { FunctionComponent } from 'react';
import { getPropertyStyleIcon } from '../../../constants/propertyIcons';
import { StyleGrid } from './StyleInputs.style';

interface Props {
  filters: SearchState['filters'];
  propertyStyles: PropertyStyle[] | null;
  handleStyleChange: UseSearchState['handleStyleChange'];
}

const StyleInputs: FunctionComponent<Props> = ({ filters, propertyStyles, handleStyleChange }) => {
  if (!propertyStyles || propertyStyles.length === 0) {
    return null;
  }

  const onChange = (key: string) => (value: boolean) => {
    handleStyleChange(key)(value);
  };

  return (
    <div style={{ width: '100%' }}>
      <InputLabel id="propertyTypesLabel">Property Types</InputLabel>

      <StyleGrid>
        {propertyStyles.map((style) => (
          <CheckItem
            key={style.key}
            checked={filters.styles.includes(style.key)}
            label={style.text}
            icon={getPropertyStyleIcon(filters.category, style.key)}
            onValueChange={onChange(style.key)}
            testID={`checkItem-${style.key}`}
          />
        ))}
      </StyleGrid>
    </div>
  );
};

export default StyleInputs;
